import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal } from "@air/component-confirmation-modal";
import { useRemoveBoardSlackIntegration } from "~/swr-hooks/slack/useRemoveBoardSlackIntegration";
export const DeleteBoardSlackIntegrationModal = (param)=>{
    let { onClose, integration, boardId } = param;
    const { removeBoardSlackIntegration } = useRemoveBoardSlackIntegration();
    const onClick = async ()=>{
        removeBoardSlackIntegration({
            integrationId: integration.integrationId,
            receiverId: integration.receiverId,
            boardId,
            channelName: integration.channelName
        });
        onClose();
    };
    const modalDescription = /*#__PURE__*/ _jsx("p", {
        className: "text-14 text-grey-11",
        children: "Are you sure you want to disconnect this Slack integration? Any other integrations you’ve created will remain active."
    });
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        isOpen: true,
        id: "delete-slack-integration-modal",
        title: "Disconnect Slack channel?",
        description: modalDescription,
        onDismiss: onClose,
        ctaPrimaryText: "Disconnect",
        onConfirm: onClick,
        ctaSecondaryText: "Cancel",
        isDangerous: true
    });
};
